import '@vanilla-extract/css/vanilla.virtual.css?ve-css=LnVnazBhODAgewogIHZpc2liaWxpdHk6IGhpZGRlbjsKfQ';
export var invisibleStyle = 'ugk0a80';